var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-line"},[_c('div',{staticClass:"tabs-line__tabs"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.id,class:[
        'tabs-line__tab',
        {'tabs-line__tab--active': _vm.currentId === tab.id}
      ],on:{"click":function($event){return _vm.changeTab(tab.id)}}},[_vm._v("\n      "+_vm._s(tab.title)+"\n    ")])}),0),_vm._v(" "),_c('div',{staticClass:"tabs-line__content"},[_vm._t(("content-" + _vm.currentId))],2)])}
var staticRenderFns = []

export { render, staticRenderFns }